<template>
  <div id='app'>
    <el-header></el-header>
    <transition name='fade' mode='out-in'>
      <router-view></router-view>
    </transition>
    <el-footer></el-footer>
  </div>
</template>

<script>
import elHeader from './components/Header'
import elFooter from './components/Footer'
export default {
  name: 'app',
  components: {
    elHeader,
    elFooter
  },
  mounted () {
    let lang = localStorage.getItem('localeLanguage') || (navigator.language || navigator.browserLanguage).toLowerCase()
    // 繁体中文
    if (lang === 'zh-hk' || lang === 'zh-mo' || lang === 'zh-tw' || lang === 'td') {
      lang = 'zh-td'
    } else if (lang.indexOf('cn') > -1) {
      lang = 'zh-cn'
    } else if (lang.indexOf('es') > -1) {
      // 西班牙语种
      lang = 'spa'
    } else if (lang.indexOf('ru') > -1) {
      // 俄罗斯语种
      lang = 'ru'
    }
    switch (lang) {
      case 'zh-td':
        this.$i18n.locale = 'td'
        break
      case 'zh-cn':
        this.$i18n.locale = 'cn'
        break
      case 'ru':
        this.$i18n.locale = 'rus'
        break
      case 'spa':
        this.$i18n.locale = 'spa'
        break
      default:
        this.$i18n.locale = 'en'
    }
    localStorage.setItem('localeLanguage', this.$i18n.locale)
    console.log('当前语言：' + lang)
  }
}
</script>

<style lang='scss'>
// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

#app {
  /*font-family: 'Open Sans,sans-serif';*/
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: 300;
  color: #333;
  line-height: 1.5;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  position: relative;
  .main {
    margin-top: 0.6rem;
    font-size: 0.1em;
    @media screen and (max-width: 760px) {
      margin-top: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?359feed8